module.exports = __webpack_public_path__ + "static/media/sveittur.4411275a.svg";